import * as moment from 'moment';
import { SVMMinimumDateString, SVMDateFormat } from "../constants";


export function isStringNullOrWhiteSpace(str) {
    if (str === undefined || str === null || str === '' || (str.trim !== undefined && str.trim() === '')) {
        return true;
    }

    return false;
}

// Cannot be startsWith, because that is already taken.
export function beginsWith(text, search) {
    if (text.length >= search.length) {
        return text.substr(0, search.length) === search;
    }

    return false;
}


export function isDateStringNullOrEmpty(dateString) {
    if (isStringNullOrWhiteSpace(dateString) || dateString === SVMMinimumDateString) {
        return true;
    }

    return false;
}

export function isDateValid(d) {
    return d instanceof Date && !isNaN(d);
}


export function isValidEmail(email) {
    var validator = require("email-validator");
    return validator.validate(email);
}

export function isHtmlLink(link) {
    return beginsWith(link.toLowerCase(), 'http') || beginsWith(link.toLowerCase(), 'www');
}



// WEBPACK FOOTER //
// ./src/tools/validator.js